export const cellClasses = (cell, data, focusCell, { groupIndex, cellIndex, groupCount, cellCount }) => {
  const classes = typeof cell.class === 'function' ? cell.class(data) : cell.class;
  const extraClasses = !classes
    ? {}
    : typeof classes === 'string'
      ? { [classes]: true }
      : classes;
  return {
    focusCell,
    group_first: groupIndex !== 0 && cellIndex === 0,
    group_last: groupIndex !== groupCount - 1 && cellIndex === cellCount - 1,
    ...variantClasses(cell),
    ...extraClasses,
  };
};
export const variantClasses = ({ variant, align = 'start', }) => {
  const variants = typeof variant === 'string' ? [variant] : variant ?? [];
  return {
    no_pad: variants.includes('no-pad'),
    borderless: variants.includes('borderless'),
    full_width: variants.includes('full-width'),
    [align]: align !== 'start',
  };
};
//# sourceMappingURL=cellClasses.js.map
